import React from 'react';
import styled from 'styled-components';

const IconImage = styled.img`
    width: 15px;
    height: 15px;
`;

export default IconImage;


// WEBPACK FOOTER //
// ./src/components/IconImage.js